import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch (err) {
      console.error("forgot", err);
    } finally {
      setSent(true);
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="glass-strong rounded-2xl p-6">
        <h1 className="font-display text-2xl font-bold mb-1">Mot de passe oublié</h1>
        <p className="text-sm text-slate-400 mb-6">Entrez votre email, nous vous enverrons un lien de réinitialisation.</p>

        {sent ? (
          <div className="space-y-4">
            <div className="rounded-lg bg-emerald-500/10 border border-emerald-500/30 p-4 text-sm text-emerald-300">
              Si cette adresse est enregistrée, un email avec un lien valable <b>1 heure</b> vient d'être envoyé.
            </div>
            <Link to="/login" data-testid="fp-back-login" className="inline-flex items-center gap-1 text-sm text-[#FF6B6B] hover:underline">
              <ArrowLeft size={14}/> Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-900/60 border border-slate-700/60 focus-within:border-[#FF6B6B]">
              <Mail size={16} className="text-slate-400" />
              <input data-testid="fp-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="votre@email.com" className="bg-transparent flex-1 outline-none text-sm" />
            </div>
            <button data-testid="fp-submit" disabled={loading} className="w-full btn-coral py-2.5 rounded-lg text-sm">{loading ? "…" : "Envoyer le lien"}</button>
            <Link to="/login" className="block text-center text-xs text-slate-400 hover:text-white mt-3">Retour à la connexion</Link>
          </form>
        )}
      </div>
    </div>
  );
}
